import { LaunchDarklyUser } from "@/models/launch-darkly-user";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import { LDFlagChangeset } from "launchdarkly-js-client-sdk";

@Module({ name: "AuthStore", namespaced: true })
class AuthStore extends VuexModule {
  private userIsAuthenticated = false;
  private accessToken = "";
  private signedInUser: null | any = null;
  private sites: string[] = [];
  private launchDarklyUser: LaunchDarklyUser = { anonymous: true };
  private launchDarklyFlags: LDFlagChangeset | null = null;

  @Mutation
  private setSignedInUser(user: any) {
    this.signedInUser = user;
    if (user != null) {
      this.userIsAuthenticated = true;
    }
  }

  @Mutation
  private setAccessToken(token: string) {
    this.accessToken = token;
  }

  @Mutation
  private setAuthState(state: boolean) {
    this.userIsAuthenticated = state;
    if (state === false) {
      this.signedInUser = null;
      this.accessToken = "";
    }
  }

  @Mutation
  private setUserAsNull() {
    this.signedInUser = null;
    this.userIsAuthenticated = false;
    this.accessToken = "";
  }

  @Mutation
  private setSites(sites: string[]) {
    this.sites = sites;
  }

  @Mutation
  private setLaunchDarklyUser(launchDarklyUser: LaunchDarklyUser) {
    this.launchDarklyUser = launchDarklyUser;
  }

  @Mutation private setLaunchDarklyFlags(flags: LDFlagChangeset | null) {
    this.launchDarklyFlags = flags;
  }

  @Action({ rawError: true })
  public updateSignedInUser(user: any) {
    this.context.commit("setSignedInUser", user);
  }

  @Action({ rawError: true })
  public updateAuthState(state: boolean) {
    this.context.commit("setAuthState", state);
  }

  @Action({ rawError: true })
  public updateAccessToken(token: string) {
    this.context.commit("setAccessToken", token);
  }

  @Action({ rawError: true })
  public signOutUser() {
    this.context.commit("setUserAsNull");
  }

  @Action
  public updateSites(sites: string[]) {
    this.context.commit("setSites", sites);
  }

  @Action
  public updateLaunchDarklyUser(launchDarklyUser: LaunchDarklyUser) {
    this.context.commit("setLaunchDarklyUser", launchDarklyUser);
  }

  public get getUserAuthenticationState(): boolean {
    return this.userIsAuthenticated;
  }

  public get getSignedInUser(): null | any {
    return this.signedInUser;
  }

  public get getAccessToken(): string {
    return this.accessToken;
  }

  public get getSites(): string[] {
    return this.sites;
  }

  public get getLaunchDarklyUser(): LaunchDarklyUser {
    return this.launchDarklyUser;
  }

  public get getLaunchDarklyFlags(): LDFlagChangeset | null {
    return this.launchDarklyFlags;
  }
}

export default AuthStore;
